import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import { AlertTriangle, XCircle, Info, Clock, Users } from 'lucide-react';

const IncidentTrackingSystem = ({ errors, activeUsers }) => {
    const { t } = useLanguage();

    const getIncidentSeverity = (error) => {
        if (error.error_count > 10) return 'critical';
        if (error.error_count > 5) return 'high';
        if (error.error_count > 2) return 'medium';
        return 'low';
    };

    const getSeverityConfig = (severity) => {
        const configs = {
            critical: { color: '#EF4444', icon: XCircle, label: `${t('systemHealthConcurrentUsers')}` },
            high: { color: '#F59E0B', icon: AlertTriangle, label: `${t('high_systemHealth')}` },
            medium: { color: '#EAB308', icon: AlertTriangle, label: `${t('middle_systemHealth')}` },
            low: { color: '#84CC16', icon: Info, label: `${t('low_systemHealth')}` }
        };
        return configs[severity] || configs.low;
    };

    const IncidentItem = ({ error, index }) => {
        const severity = getIncidentSeverity(error);
        const severityConfig = getSeverityConfig(severity);
        const SeverityIcon = severityConfig.icon;

        const getIncidentDescription = (source) => {
            const descriptions = {
                'pomodoro_sessions': `${t('pomodoro_sessions_getIncidentDescription')}`,
                'ai_conversations': `${t('ai_conversations_getIncidentDescription')}`,
                'payments': `${t('payments_getIncidentDescription')}`
            };
            return descriptions[source] || 'Bilinmeyen hata kaynağı';
        };

        return (
            <div className="incident-item">
                <div className="incident-severity" style={{ borderLeftColor: severityConfig.color }}>
                    <SeverityIcon size={16} style={{ color: severityConfig.color }} />
                    <span className="severity-label">{severityConfig.label}</span>
                </div>
                <div className="incident-content">
                    <div className="incident-source">{error.source}</div>
                    <div className="incident-description">
                        {getIncidentDescription(error.source)}
                    </div>
                    <div className="incident-meta">
                        <Clock size={12} />
                        <span>{t('last_seven_days_systemHealth')} {error.error_count} {t('times_systemHealth')}</span>
                    </div>
                </div>
                <div className="incident-count" style={{ backgroundColor: severityConfig.color }}>
                    {error.error_count}
                </div>
            </div>
        );
    };

    return (
        <div className="incident-tracking-system">
            <div className="system-header">
                <AlertTriangle size={20} />
                <h3>{t('systemHealthIncidentTracker')}</h3>
                <div className="active-users">
                    <Users size={16} />
                    <span>{activeUsers || 0} {t('systemHealthConcurrentUsers')}</span>
                </div>
            </div>

            <div className="incidents-summary">
                <div className="summary-stats">
                    <div className="summary-stat critical">
                        <span className="stat-count">
                            {errors?.filter(e => getIncidentSeverity(e) === 'critical').length || 0}
                        </span>
                        <span className="stat-label">{t('critic_systemHealth')}</span>
                    </div>
                    <div className="summary-stat high">
                        <span className="stat-count">
                            {errors?.filter(e => getIncidentSeverity(e) === 'high').length || 0}
                        </span>
                        <span className="stat-label">{t('high_systemHealth')}</span>
                    </div>
                    <div className="summary-stat medium">
                        <span className="stat-count">
                            {errors?.filter(e => getIncidentSeverity(e) === 'medium').length || 0}
                        </span>
                        <span className="stat-label">{t('middle_systemHealth')}</span>
                    </div>
                    <div className="summary-stat low">
                        <span className="stat-count">
                            {errors?.filter(e => getIncidentSeverity(e) === 'low').length || 0}
                        </span>
                        <span className="stat-label">{t('low_systemHealth')}</span>
                    </div>
                </div>
            </div>

            <div className="incidents-list">
                {errors && errors.length > 0 ? (
                    errors.map((error, index) => (
                        <IncidentItem key={index} error={error} index={index} />
                    ))
                ) : (
                    <div className="no-incidents">
                        <Info size={32} />
                        <p>{t('systemHealthNoIncidentsLogged')}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default IncidentTrackingSystem;